import * as React from 'react';

// ===================== Nest =====================

const TriggerContext = /*#__PURE__*/React.createContext(null);
export default TriggerContext;

// ==================== Unique ====================

export const UniqueContext = /*#__PURE__*/React.createContext(null);